import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=0edf8645&scoped=true&lang=pug&"
import script from "./OffersView.vue?vue&type=script&lang=js&"
export * from "./OffersView.vue?vue&type=script&lang=js&"
import style0 from "./OffersView.vue?vue&type=style&index=0&id=0edf8645&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf8645",
  null
  
)

export default component.exports